var React = require('react');

function BlobInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M295.926 57.89C132.45 57.89 0-85.1 0 78.376s132.524 296 296 296 296-132.524 296-296S459.402 57.89 295.926 57.89Z","fill":"#F2F2F5","fillRule":"evenodd"}));
}

BlobInline.defaultProps = {"viewBox":"0 0 592 375"};

module.exports = BlobInline;

BlobInline.default = BlobInline;
